import { styled } from "@mui/material/styles";


export const StyledCard = styled("div")(() => ({
    dislay: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const StyledCardHeader = styled("div")(() => ({
    padding: "0 1rem"

}));

export const StyledComplaint = styled("p")(({ theme }) => ({
    fontSize: "1rem",
    color: theme.palette.text.secondary,
}));

export const StyledDemandCode = styled("span")(({ theme }) => ({
    fontSize: "0.8rem",
    color: theme.palette.text.secondary
}));

export const StyledCardBody = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "1rem",
    margin: " 0 1rem",
    background: theme.palette.background.main,
    borderRadius: "35px",
    border: `1px solid ${theme.palette.background.secondary}`,
}));

export const StyledProfileImage = styled("img")(({ theme }) => ({
    width: "70px",
    height: "70px",
    borderRadius: "100%",
    border: `2px solid ${theme.palette.primary.main}`,
    objectFit: "cover"
}));

export const StyledDoctorInfo = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
}));

export const StyledDoctorFullname = styled("span")(() => ({
    fontSize: "0.9rem"
}));

export const StyledDoctorBranch = styled("span")(({ theme }) => ({
    fontSize: "0.8rem",
    color: theme.palette.text.secondary
}));

export const StyledCardFooter = styled("div")(() => ({}));

export const StyledAppointmentDate = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "1rem",

}));

export const StyledAppointmentDay = styled("div")(({ theme }) => ({
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    fontSize: "0.9rem",
    span: {
        color: theme.palette.text.secondary,
        fontWeight: "bold"
    }
}));

export const StyledAppointmentHour = styled("div")(({ theme }) => ({
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    fontSize: ".9rem",
    span: {
        color: theme.palette.text.secondary,
        fontWeight: "bold"
    }

}));

export const StyledButtonContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "1rem",
    padding: "1rem",
    [theme.breakpoints.down("sm")]: {
        justifyContent: "center"
    }

}));

export const StyledAppointmentInfo = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem 2rem",
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        justifyContent: "center",
        gap: "1rem"
    }
}))

export const StyledStatus = styled("span")(({ status, theme }) => ({
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
    span: {
        color: status === "waiting" ? theme.palette.info.main :
            status === "started" ? theme.palette.success.main :
                (status === "patientjoined" || status === "doctorjoined") ? theme.palette.warning.main :
                    status == "outdated" ? theme.palette.error.main :
                        theme.palette.info.main,
        fontSize: "1rem",
        fontWeight: "bold"
    }
}))